import type { ProductInfoModel, ProductStoreStockViewModel } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

type FindInStoreQuickViewType = {
    isOpen: boolean;
    productId?: number;
    productInfo?: ProductInfoModel;
    showClickAndCollectToggle?: boolean;
    clickAndCollectOnly?: boolean;
    showSelectParcelShop?: boolean;
    isClickAndCollect?: boolean;
    isBasket?: boolean;
};

export const FindInStoreQuickViewMediatorAtom = mediatorAtom<FindInStoreQuickViewType>({ isOpen: false });

export function useFindInStoreQuickView() {
    return useMediatorState(FindInStoreQuickViewMediatorAtom);
}

export const FindInStoreWithStoreStockQuickViewMediatorAtom = mediatorAtom<
    FindInStoreQuickViewType & {
        storeStockModel?: ProductStoreStockViewModel;
    }
>({ isOpen: false });

export function useFindInStoreWithStoreStockQuickView() {
    return useMediatorState(FindInStoreWithStoreStockQuickViewMediatorAtom);
}
